var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.integrator === 'upos' && _vm.full)?_c('upos-logo-full'):(_vm.integrator === 'upos' && !_vm.full)?_c('upos-logo-min'):(_vm.full)?_c('alt-logo-full'):_c('alt-logo-min')}
var staticRenderFns = []

export { render, staticRenderFns }